import React from "react";
import { CheckCircle2, ArrowRight, Sparkles } from "lucide-react";

export default function RegisterComplete({ user, go }) {
  return (
    <section className="screen rc-screen">
      <div className="rc-bg-orb rc-bg-orb-1" />
      <div className="rc-bg-orb rc-bg-orb-2" />
      <div className="rc-bg-orb rc-bg-orb-3" />

      <div className="topbar">
        <span style={{ width: 38 }} />
        <div className="section-title">Uğurlu qeydiyyat</div>
        <span style={{ width: 38 }} />
      </div>

      <div className="content rc-content">
        {/* Success emblem with logo */}
        <div className="rc-emblem">
          <div className="rc-emblem-glow" />
          <div className="rc-emblem-ring" />
          <div className="rc-emblem-inner">
            <img src="/assets/logo.png" alt="PULPAY" />
          </div>
          <div className="rc-check-badge">
            <CheckCircle2 size={18} strokeWidth={2.6} />
          </div>
          <span className="rc-sp rc-sp-1"><Sparkles size={16} /></span>
          <span className="rc-sp rc-sp-2"><Sparkles size={12} /></span>
          <span className="rc-sp rc-sp-3"><Sparkles size={14} /></span>
        </div>

        <div className="rc-title-wrap">
          <span className="rc-badge">
            <CheckCircle2 size={12} /> Təsdiqləndi
          </span>
          <h1 className="rc-title">Təbriklər, {user?.firstName || "istifadəçi"}!</h1>
          <p className="rc-desc">
            Hesabınız uğurla yaradıldı. Aşağıdakı düymə ilə kredit sisteminə giriş edin.
          </p>
        </div>

        {/* Compact info */}
        <div className="rc-info">
          <div className="rc-info-row">
            <span>Ad Soyad</span>
            <b>{user?.firstName} {user?.lastName}</b>
          </div>
          <div className="rc-info-row">
            <span>FIN</span>
            <b>{user?.fin}</b>
          </div>
          <div className="rc-info-row">
            <span>Vəsiqə</span>
            <b>{user?.docSeries} {user?.docNumber}</b>
          </div>
          <div className="rc-info-row">
            <span>Doğum</span>
            <b>{user?.birthDate}</b>
          </div>
          <div className="rc-info-row">
            <span>Telefon</span>
            <b>{user?.phone || "-"}</b>
          </div>
        </div>

        {/* Animated CTA */}
        <button className="rc-cta" onClick={() => go("home")}>
          <span className="rc-cta-shine" />
          <span className="rc-cta-txt">Giriş et</span>
          <ArrowRight size={20} strokeWidth={3} className="rc-cta-arrow" />
        </button>
      </div>
    </section>
  );
}
